import { FC } from 'react';
import kebabCase from 'lodash/kebabCase';
import useRuntime from '@belong/providers/runtime';
import { IMoleculeNavLinkGroup } from '@belong/types';
import NavLinkFooter from '../../actions/NavLinkFooter';
import * as GFooter from './GlobalFooter.styles';

interface IGlobalFooterNavLinkGroup {
  navLinkGroup: IMoleculeNavLinkGroup;
}

const GlobalFooterNavLinkGroup: FC<IGlobalFooterNavLinkGroup> = ({ navLinkGroup }) => {
  const { currentBreakpoint } = useRuntime();

  return (
    <>
      <GFooter.NavLinkGroupHeading variant={currentBreakpoint === 'xs' ? 'small' : 'xsmall'} id={navLinkGroup.id}>
        {navLinkGroup.label}
      </GFooter.NavLinkGroupHeading>
      <GFooter.NavLinkGroupLinks aria-labelledby={navLinkGroup.id}>
        {navLinkGroup.navLinks.map(navLink => (
          <li key={kebabCase(navLink.label).toLowerCase()}>
            <NavLinkFooter aria-label={navLink['aria-label']} href={navLink.href} label={navLink.label} />
          </li>
        ))}
      </GFooter.NavLinkGroupLinks>
    </>
  );
};

GlobalFooterNavLinkGroup.displayName = 'GlobalFooterNavLinkGroup';
export default GlobalFooterNavLinkGroup;
